import { render, staticRenderFns } from "./WarehouseLocationListComponent.vue?vue&type=template&id=33dc2cf3"
import script from "./WarehouseLocationListComponent.vue?vue&type=script&lang=js"
export * from "./WarehouseLocationListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports